import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ActiveHeartIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 19 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.21609 15.616C8.59922 15.8671 9.04487 16.0004 9.5 16C9.9553 15.9999 10.401 15.866 10.7839 15.6142C11.8717 14.9 13.9613 13.4342 15.7296 11.6444C17.8996 9.4471 19 7.37776 19 5.49154C19 4.18087 18.6209 2.97998 17.9035 2.01909C17.2232 1.10542 16.2622 0.452027 15.1749 0.163865C14.0876 -0.124296 12.9371 -0.0304962 11.9083 0.430197C10.9874 0.834198 10.1661 1.51909 9.5 2.4302C8.83391 1.52131 8.01261 0.83642 7.09174 0.430197C6.06287 -0.0304962 4.91238 -0.124296 3.82509 0.163865C2.73779 0.452027 1.77681 1.10542 1.09652 2.01909C0.379131 2.97998 0 4.18087 0 5.49154C0 7.37776 1.10043 9.44799 3.27043 11.6462C5.0387 13.436 7.12913 14.9018 8.21609 15.616Z"
        fill="url(#paint0_linear_30369_5831)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_30369_5831"
          x1="3.5"
          y1="-1.51364e-07"
          x2="16"
          y2="16.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E03409" />
          <stop offset="1" stopColor="#FF8800" />
        </linearGradient>
      </defs>
    </svg>
  )
})

ActiveHeartIcon.displayName = 'ActiveHeartIcon'
